import React, { useContext, useEffect } from "react";
import { InsightSectionLegacy } from "./legacy/InsightSection";
import { InsightSectionNew } from "./InsightSectionNew";
import { OpportunitySectionProps } from "./types";
import { InsightContext } from "./context/InsightContextProvider";
import { setInsightState } from "./context/insightSlice";

// Wrapper component that handles conditional rendering
export const InsightSection: React.FC<OpportunitySectionProps> = props => {
  const {
    setOpportunityId,
    sideContentMode,
    disableNewUI = false,
    onAskAI,
    emptyTitle,
    emptySubTitle,
    showTimeSavings = false,
    onDateRangeChange,
    ...contextProps
  } = props;
  const { dispatch } = useContext(InsightContext);

  // New UI is enabled by default unless disableNewUI is true
  const useNewUI = !disableNewUI;

  // Initialize and update state when props change
  useEffect(() => {
    if (!useNewUI) {
      return;
    }
    dispatch(setInsightState(contextProps));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    contextProps.opportunities,
    contextProps.selectedOpportunityId,
    contextProps.totalRuns,
    contextProps.startDate,
    contextProps.endDate,
    contextProps.showMultiStatementError,
    contextProps.extraContent,
    contextProps.showScheduledEventsActivity,
    contextProps.queryId,
    contextProps.showActionsDropdown,
    contextProps.integrationIds,
    contextProps.description,
    contextProps.sqlLineage,
    contextProps.queryText,
    useNewUI,
  ]);

  if (useNewUI) {
    return (
      <InsightSectionNew
        setOpportunityId={setOpportunityId}
        onAskAI={onAskAI}
        emptyTitle={emptyTitle}
        emptySubTitle={emptySubTitle}
        showTimeSavings={showTimeSavings}
        onDateRangeChange={onDateRangeChange}
      />
    );
  }

  return (
    <InsightSectionLegacy
      {...contextProps}
      setOpportunityId={setOpportunityId}
      sideContentMode={sideContentMode}
    />
  );
};
